import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;
const Introduction = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className='Title2' style={{color: appColors['ColorNa'], fontSize: '8vh'}}>Engineering Success</Paragraph>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-7vh'}}>Overview</Paragraph>
        <Text className='BaseText2'>The Design-Build-Test-Learn (DBTL) cycle is an <b>engineering technique</b> that represents a systematic and efficient approach which increases the development of <b>synthetic biology projects</b> and has been implemented to <b>solve problems</b> in this field. The DBTL is a cycle used to obtain a <b>design</b> that satisfies the desired specifications. This methodology systematizes metabolic engineering and <b>increases</b> the efficacy and generalizability. [1]<br/><br/>As students of engineering we were encouraged to tackle the <b>local problems</b> identified with the DBTL cycle as an engineering technique. In this section, we will <b>demonstrate</b> the use of the <b>DBTL</b> cycle applied in <b>our project.</b></Text>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Introduction;
